import * as React from 'react';
import './styles.scss';
import { List } from '../../atoms/list/list';
import { useEffect, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';

export type ListMenuProps = {
  list: { [id: string]: { title: string; link: string; } };
  direction?: "vertical" | "horizontal"
};

export const ListMenu: React.FunctionComponent<ListMenuProps> = ({
  list,
  direction
}: ListMenuProps) => {
  const [linkList, setLinkList] = useState<{ [id: string]: JSX.Element }>({});

  useEffect(() => {
    const newList: { [id: string]: JSX.Element } = {};
    Object.keys(list).map((key: string) => {
      newList[key] = (<ScrollLink href="#" to={list[key].link} activeClass={"active"} spy={true} smooth={true} duration={500} tabIndex={0}>{list[key].title}</ScrollLink>);
    });

    setLinkList(newList);
  }, [list]);

  return (
    <div className="cmp-list-menu">
      <List list={linkList} direction={direction ?? "horizontal"} />
    </div>
  );
};
